import React, { useState } from 'react'
import { useIntl } from 'react-intl'

import { Icon } from '../../atoms'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '../../../shadcn/components/ui/popover'
import { formatAvgAnswerTime } from '../../../utils/owners/formatAvgAnswerTime'

export const OwnerResponsePopover = ({
  answerRate,
  avgAnswerTime,
  disableHover = false,
}: {
  answerRate: number | null | undefined
  avgAnswerTime: number | null | undefined
  disableHover?: boolean
}) => {
  const intl = useIntl()
  const [open, setOpen] = useState(false)

  const handleMouseEnter = () => {
    if (!disableHover) {
      setOpen(true)
    }
  }

  const handleMouseLeave = () => {
    if (!disableHover) {
      setOpen(false)
    }
  }

  const formattedAvgTime =
    avgAnswerTime && avgAnswerTime > 0
      ? formatAvgAnswerTime(avgAnswerTime)
      : null

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger
        className='flex gap-2 text-grey-700 hover:cursor-pointer'
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {answerRate && (
          <div className='flex items-center gap-1'>
            <Icon name='chatOutline' size={14} />
            <span>{`${answerRate}%`}</span>
          </div>
        )}

        {formattedAvgTime && (
          <div className='flex items-center gap-1'>
            <Icon name='clock' size={14} />
            <span className='whitespace-nowrap'>{formattedAvgTime}</span>
          </div>
        )}
      </PopoverTrigger>
      <PopoverContent
        align='start'
        usePortal={false}
        className='w-72 rounded-md border border-grey-400 bg-white px-4 py-3 shadow-md'
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <div className='text-gray-700 flex flex-col gap-1 text-sm'>
          {answerRate && (
            <div className='flex items-center gap-1'>
              <Icon name='chatOutline' size={14} />
              <div>
                {intl.formatMessage({
                  id: 'ui.OwnerResponsePopover.answerRatePopover',
                  defaultMessage: 'Taux de réponse :',
                })}{' '}
                <strong>{`${answerRate}%`}</strong>
              </div>
            </div>
          )}
          {formattedAvgTime && (
            <div className='flex items-center gap-1'>
              <Icon name='clock' size={14} />
              <div>
                {intl.formatMessage({
                  id: 'ui.OwnerResponsePopover.avgAnswerTime',
                  defaultMessage: 'Temps de réponse moyen :',
                })}{' '}
                {formattedAvgTime}
              </div>
            </div>
          )}
        </div>
      </PopoverContent>
    </Popover>
  )
}

export default OwnerResponsePopover
